import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import SpzaComponent from './../spzaComponent';
import Animation from '../animation';
class AnimationModal extends SpzaComponent {
    renderImpl() {
        return /*#__PURE__*/ _jsx("div", {
            role: "dialog",
            "aria-label": "animation is now open and playing",
            className: "animationModalClass",
            children: /*#__PURE__*/ _jsx("div", {
                className: "animationCanvas",
                children: /*#__PURE__*/ _jsx(Animation, {
                    isCircular: true
                })
            })
        });
    }
}
export { AnimationModal as default };
